import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { GET_NODES_TOPO_SW_API_URL } from '../Optics/OpticApiConfig';

const DescriptionSwitchDialog = ({ open, onClose, item}) => {

const [topologyData, setTopologyData] = useState([]);


  useEffect(() => {
    if (open && item?.ip) {
      fetch(`${GET_NODES_TOPO_SW_API_URL}?ip=${item.ip}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, 
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            return response.text().then(text => { throw new Error(text); });
          }
          return response.json();
        })
        .then((data) => setTopologyData(data))
        .catch((error) => console.error("Ошибка при загрузке данных:", error.message));
      }      
  }, [open, item]);


  const handleCloseDialogs = () => {
    onClose();
  };


    return (
  
    <Dialog open={open} className="dialogStyle" >
    
      <DialogContent>  
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>{item.model}</label><br/>
      
      <span style={{ fontWeight: 'bold', fontSize: '16px', color: "#00000099" }}>IP:</span> <span style={{ fontSize: '14px', color: "#d4d4d4" }}>{item.ip}</span><br />
      <span style={{ fontWeight: 'bold', fontSize: '16px', color: "#00000099" }}>Mac:</span> <span style={{ fontSize: '14px', color: "#d4d4d4" }}>{item.mac}</span><br />
      <hr className='horizontalLineDialog'/>

       {topologyData.length > 0 ? (
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
            <thead>
              <tr style={{ backgroundColor: "#333", color: "#fff" }}>
                <th style={thStyle}>Порт</th>
                <th style={thStyle}></th>
                <th style={thStyle}>Модель</th>
                <th style={thStyle}>IP</th>
                <th style={thStyle}>Порт</th>
                <th style={thStyle}>MAC</th>
                <th style={thStyle}>VLAN</th>
              </tr>
            </thead>
            <tbody>
              {topologyData.map((row, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#444" : "#555", color: "#fff" }}>
                  <td style={tdStyle}>{row.s_port}</td>
                  <td style={tdStyle}>
                    <img src="./vektor.png" alt="Vektor" style={{ width: "30px", height: "30px" }} />
                  </td>
                  <td style={tdStyle}>{row.model}</td>
                  <td style={tdStyle}>{row.dest_ip}</td>
                  <td style={tdStyle}>{row.dest_port}</td>
                  <td style={tdStyle}>{row.dest_mac}</td>
                  <td style={tdStyle}>{row.vlan}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          null
        )}
    

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>


      

      
    </Dialog>
  );
}

// Стили для таблицы
const thStyle = {
  color: "#c2c2c2",
  fontSize: "12px",
  padding: "8px",
  textAlign: "left",
  borderBottom: "1px solid #666",
};

const tdStyle = {
  color: "#d4d4d4",
  fontSize: "14px",
  padding: "8px",
  borderBottom: "1px solid #666",
};


export default DescriptionSwitchDialog;